import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminScope } from '../context/AdminScopeContext';
import { useLanguage } from '../hooks/useLanguage';
import { isPathAllowedForAdminScope } from '../config/adminScope';

const AdminRouteGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { scope, loading, homePath } = useAdminScope();
  const { getPathWithoutLang } = useLanguage();
  const location = useLocation();

  if (loading) {
    return null;
  }

  const currentPath = getPathWithoutLang(location.pathname);
  if (!isPathAllowedForAdminScope(currentPath, scope)) {
    return <Navigate to={homePath} replace />;
  }

  return <>{children}</>;
};

export default AdminRouteGuard;
